import { defineStore } from "pinia";
import { ref } from "vue";

export interface PageFocusObserver {
  onPageFocus: () => void;
}

export const usePageFocusObserver = defineStore("pageFocusObserver", () => {
  const observers = ref<PageFocusObserver[]>([]);

  const subscribe = (observer: PageFocusObserver) => {
    observers.value.push(observer);
  };

  const unsubscribe = (observer: PageFocusObserver) => {
    observers.value = observers.value.filter((o) => o !== observer);
  };

  const notify = () => {
    for (const observer of observers.value) {
      observer.onPageFocus();
    }
  };

  return {
    subscribe,
    unsubscribe,
    notify,
  };
});
